 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLDED from '@/components/xhtml/ded'
 import XHTMLEPI from '@/components/xhtml/epi'
 import XHTMLCONTENT from '@/components/xhtml/content'
 import XHTMLFM1 from '@/components/xhtml/fm1'
 import XHTMLFM2 from '@/components/xhtml/fm2'
 import XHTMLFM3 from '@/components/xhtml/fm3'
 import XHTMLCHAPTER1 from '@/components/xhtml/chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/chapter5'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLBM from '@/components/xhtml/bm'
 import XHTMLATA from '@/components/xhtml/ata'
 import XHTMLADC from '@/components/xhtml/adc'
 import XHTMLCRE from '@/components/xhtml/cre'
 import XHTMLCOP from '@/components/xhtml/cop'
 import XHTMLATP from '@/components/xhtml/atp'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/ded",
 			"name" : "xhtml/ded",
 			"component" : XHTMLDED
 		},
 		{
 			"path" : "/xhtml/epi",
 			"name" : "xhtml/epi",
 			"component" : XHTMLEPI
 		},
 		{
 			"path" : "/xhtml/content",
 			"name" : "xhtml/content",
 			"component" : XHTMLCONTENT
 		},
 		{
 			"path" : "/xhtml/fm1",
 			"name" : "xhtml/fm1",
 			"component" : XHTMLFM1
 		},
 		{
 			"path" : "/xhtml/fm2",
 			"name" : "xhtml/fm2",
 			"component" : XHTMLFM2
 		},
 		{
 			"path" : "/xhtml/fm3",
 			"name" : "xhtml/fm3",
 			"component" : XHTMLFM3
 		},
 		{
 			"path" : "/xhtml/chapter1",
 			"name" : "xhtml/chapter1",
 			"component" : XHTMLCHAPTER1
 		},
 		{
 			"path" : "/xhtml/chapter2",
 			"name" : "xhtml/chapter2",
 			"component" : XHTMLCHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js